import React from 'react';
import { Route } from 'react-router-dom';

// A special wrapper for <Route> that knows how to
// handle "sub"-routes by passing them in a `routes`
// prop to the component it renders.
function RouteWithSubRoutes(route) {
  const Component = route.component;
  return (
    <Route
      path={route.path}
      render={props => (
        // pass the sub-routes down to keep nesting
        <Component {...props} routes={route.routes} {...route.routeProps} />
      )}
    />
  );
}

export default RouteWithSubRoutes;
